var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.113,
    height: 30.113,
    viewBox: "0 0 30.113 30.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M23.056,8A15.056,15.056,0,1,0,38.113,23.056,15.054,15.054,0,0,0,23.056,8Zm9.429,11.857L21.315,31.028a.971.971,0,0,1-1.373,0l-6.314-6.314a.971.971,0,0,1,0-1.373L15,21.967a.971.971,0,0,1,1.374,0l4.253,4.253,9.11-9.11a.971.971,0,0,1,1.374,0l1.373,1.374A.971.971,0,0,1,32.485,19.857Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M103.979,167.575a.971.971,0,0,1-1.373,0l-6.314-6.314a.971.971,0,0,1,0-1.373l1.373-1.374a.971.971,0,0,1,1.374,0l4.253,4.253,9.11-9.11a.971.971,0,0,1,1.374,0l1.373,1.374a.971.971,0,0,1,0,1.373Z",
    transform: "translate(-82.664 -136.547)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.d6d511c202fb9c430a11b858a58d4543.svg";
export { ForwardRef as ReactComponent };